import { createActions, createReducer } from 'reduxsauce';
import { cloneDeep, forEach, set } from 'lodash';

export { default as thunks } from './thunks';

/* ------------- Initial State ------------- */
export const INITIAL_STATE = {
	data : {
		totalCount  : 0,
		counts      : {},
		listData    : [],
		checks      : [],
		clients     : [],
		projects    : [],
		locations   : [],
		details     : {},
		hasNext     : false,
		pagingToken : null,
	},
	details        : {},
	invoiceSummary : {},
	receipt        : {},
	filters        : {
		displayCount     : 25,
		pageNumber       : 1,
		sortedColumn     : 'StartDateTime',
		asc              : true,
		locationId       : null,
		clientId         : null,
		projectId        : null,
		officerId        : null,
		jobStartDate     : null,
		jobEndDate       : null,
		invoiceStartDate : null,
		invoiceEndDate   : null,
		isEstimate       : 'null',
		prePay           : null,
		id               : [],
	},
	counts : {
		review  : 0,
		payment : 0,
		dispute : 0,
	},
	selectAll : {
		review   : false,
		payments : false,
		disputes : false,
	},
	loading : {
		listData       : false,
		counts         : false,
		clients        : false,
		projects       : false,
		locations      : false,
		details        : false,
		invoiceSummary : false,
		receipt        : false,
		status         : false,
		paymentModal   : false,
	},
	collapse : {
		notes         : false,
		attachments   : false,
		statusHistory : false,
	},
	modals : {
		disputeForm         : false,
		paymentSummaryModal : false,
		paymentConfirmation : false,
		tourModal           : false,
	},
	disputeConfirmation   : false,
	activeTransactionId   : '',
	activeInvoiceIds      : [],
	activeDisputeId       : '',
	disputeReasons        : [],
	totalCountForCheckbox : 0,
	activeTourTab         : 0,
	successfulUpdateIds   : [],
	officerOrAgency       : 'officer',
};

/* ------------- Types and Action Creators ------------- */
export const { Types, Creators } = createActions({
	receiveData           : ['collection'],
	setLoading            : ['property', 'value'],
	updateStoreProperties : ['collection'],
	updatePaymentsFilter  : ['propertyObject'],
	updateFilters         : ['collection'],
	updateModalState      : ['modal', 'value'],
	resetPaymentsValues   : ['paymentFieldArray'],
	resetPaymentsFilter   : ['resetFilterParams'],
}, { prefix : '@payments/' });

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
	[Types.RECEIVE_DATA] : (state, { collection }) => {
		const newState = cloneDeep(state);

		forEach(collection, ({ property, value }) => {
			set(newState, ['data', property], value);
		});

		return newState;
	},

	[Types.SET_LOADING] : (state, { property, value }) => ({
		...state,
		loading : {
			...state.loading,
			[property] : value,
		},
	}),

	[Types.UPDATE_STORE_PROPERTIES] : (state, { collection }) => {
		const newState = cloneDeep(state);

		forEach(collection, (value, property) => set(newState, property, value));

		return newState;
	},
	[Types.UPDATE_PAYMENTS_FILTER] : (state, { propertyObject }) => {
		const newState = cloneDeep(state);

		forEach(propertyObject, (item, key) => {
			newState.filters[key] = item;
		});

		return newState;
	},
	[Types.UPDATE_MODAL_STATE] : (state, { modal, value }) => {
		const newState = cloneDeep(state);
		newState.modals[modal] = value;
		return newState;
	},

	[Types.UPDATE_FILTERS] : (state, { collection }) => {
		const newState = cloneDeep(state);

		forEach(collection, ({ property, value }) => {
			set(newState, ['filters', property], value);
		});

		return newState;
	},

	[Types.RESET_PAYMENTS_VALUES] : (state, { paymentFieldArray = null }) => {
		const newState = cloneDeep(state);
		if (paymentFieldArray) {
			forEach(paymentFieldArray, (item) => {
				newState[item] = INITIAL_STATE[item];
			});
			return newState;
		} return INITIAL_STATE;
	},
	[Types.RESET_PAYMENTS_FILTER] : (state, { resetFilterParams = [] }) => {
		const newState = cloneDeep(state);
		if (!resetFilterParams.length) newState.filters = INITIAL_STATE.filters;
		else {
			forEach(resetFilterParams, (item) => {
				newState.filters[item] = INITIAL_STATE.filters[item];
			});
		}
		return newState;
	},
});

export default Creators;
